import { useMutation } from 'react-query';
import { useNotification } from 'src/providers/notificationsProvider';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { UseMutationInterface } from 'src/reactQuery/customers/mutations/interfaces/useUpdateCustomer.interface';
import { updateOrderStatus } from 'src/services/napi';
import { Project } from 'src/services/napi/projects/interfaces/fetchProjects.interface';
import { UpdateORderBodyProps } from './interfaces/orders.interface';

const updateOrderFn = async (orderId: string, body: UpdateORderBodyProps): Promise<void> => {
  const currentProject: Project | undefined = getDataFromLocalStorage(
    LocalStorageKey.CURRENT_PROJECT
  );
  if (!currentProject) return;

  await updateOrderStatus(currentProject._id, orderId, body);
};

export const useUpdateOrder = ({ onError, onSuccess }: UseMutationInterface) => {
  const { notify } = useNotification();

  return useMutation(
    // @ts-ignore-next-line
    (params: { body: UpdateORderBodyProps; orderId: string }) => {
      updateOrderFn(params.orderId, params.body);
    },
    {
      onError: () => {
        notify({ message: 'something went wrong', severity: 'error' });
        if (onError) {
          onError();
        }
      },
      onSuccess: () => {
        if (onSuccess) {
          onSuccess();
        }
      }
    }
  );
};
